import React from "react";
import classes from "../main.module.css";

const ServiceCard = ({ count, title, description, tags, icon, index }) => {
    return (
        <div className={classes.ServiceCard} data-aos="fade-up" data-aos-delay={index * 100}>
            <div className={classes.ServiceWatermark}>{count}</div>

            <div className={classes.ServiceIconWrapper}>
                {icon}
            </div>

            <h3>{title}</h3>
            <pre>{description}</pre>

            <div className={classes.ServiceTags}>
                {tags.map((tag, index) => (
                    <span key={index} className={classes.ServiceTag}>
                        {tag}
                    </span>
                ))}
            </div>
        </div>
    )
};

const Services = () => {

    const serviceData = [
        {
            count: "04",
            title: "UI/UX Design",
            description: "Crafting intuitive interfaces that balance aesthetic elegance with functional precision.",
            tags: ["Color", "Design", "Typography", "Wireframe"],
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="3" y1="9" x2="21" y2="9"></line>
                    <line x1="9" y1="21" x2="9" y2="9"></line>
                </svg>
            )
        },
        {
            count: "03",
            title: "App Development",
            description: "Engineering high-performance mobile ecosystems built for scale and seamless user engagement.",
            tags: ["Swift", "Kotlin", "React Native", "Flutter"],
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                    <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>
            )
        },
        {
            count: "01",
            title: "Web Development",
            description: "Architecting robust, scalable web platforms that drive business growth and digital presence.",
            tags: ["React", "Angular", "Django", "Node.js"],
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 18 22 12 16 6"></polyline>
                    <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
            )
        },
        {
            count: "06",
            title: "Graphic Design",
            description: "Defining brand identities through bold visual storytelling and cohesive design systems.",
            tags: ["Branding", "Vector", "Illustration", "Print"],
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
                </svg>
            )
        }
    ];

    const title = 'Precision Solutions for\nModern Businesses'
    const subTitle = 'We offer a curated suite of services designed to elevate your brand and dominate the digital landscape.'

    return (
        <section id="services" className={classes.ServicesSection}>
            <div className={classes.Services}>
                <div className={classes.ServicesHeader} data-aos="fade-up">
                    <div className={classes.ServicesTitleGroup}>
                        <pre>{title}</pre>
                    </div>
                    <pre>{subTitle}</pre>
                </div>
                <div className={classes.ServicesContainer}>
                    {serviceData.map((service, index) => (
                        <ServiceCard key={index} index={index} {...service} />
                    ))}
                </div>
            </div>
        </section>
    );

};

export default Services